import styled from "styled-components";
import { Form } from "react-bootstrap";

export default styled(Form)`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
`;
